module.exports = __webpack_public_path__ + "static/img/A112.53816f97.jpg";